import React from "react"

import { useFormContext } from "react-hook-form"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config.ts"
import { InputElement } from "@front-shared/elements/input.element.tsx"

import type { IDynamicCheckerFormInputData } from "../../../../types/data.types.ts"

export const SessionRateInput: React.FunctionComponent<
    IDynamicFormSessionRateInputProps
> = props => {
    const {
        control,
        formState: { errors },
        watch,
    } = useFormContext<IDynamicCheckerFormInputData>()

    const dataWatcher = watch()

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <InputElement
                type="number"
                label="Session Rate"
                name="sessionRate"
                reactHookControl={control as any}
                reactHookErrors={errors}
                reactHookValidations={{
                    required: FRONT_VALIDATION_CONFIG.required,
                    min: FRONT_VALIDATION_CONFIG.minAmount,
                }}
                defaultValue={
                    props.defaultSessionRate || dataWatcher.sessionRate
                }
                inputPrefix={<>$</>}
                isLabelStatic
            />
        </div>
    )
}

interface IDynamicFormSessionRateInputProps {
    className?: string
    defaultSessionRate?: string
}
